var style = {"datePicker":"Date-module_datePicker__rL92P","error":"Date-module_error__sRbcb"};

export { style as default };
//# sourceMappingURL=Date.module.scss.js.map
